import legalSentenceValidator from './sentence';

export default legalSentenceValidator;
